import { merge } from "lodash";
import ReactApexChart from "react-apexcharts";
import { Card, Box, Input } from "@mui/material";
import { fNumber } from "../../../utils/formatNumber";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { BaseOptionChart } from "../../charts";

// ----------------------------------------------------------------------
//data for 3months: Dec 22, Jan 23 and Feb 23 compared with data for Dec 21, Jan 22 and Feb 22
const CHART_DATA_Line = [
  {
    name: "Green Antibiotics prescribed in 2022",
    data: [280, 290, 330, 150, 200, 133, 33, 67, 111, 187, 230, 255],
  },
  {
    name: "Red Antibiotics prescribed in 2022",
    data: [120, 110, 140, 180, 170, 130, 13, 55, 55, 69, 112, 198],
  },
  {
    name: "Green Antibiotics prescribed in 2021",
    data: [380, 190, 530, 50, 280, 163, 3, 78, 141, 157, 239, 355],
  },
  {
    name: "Red Antibiotics prescribed in 2021",
    data: [140, 90, 135, 150, 120, 150, 65, 42, 42, 60, 12, 98],
  },
];

function AppLine(props) {
  const [chartData, setChartData] = useState([]);
  const [dateRange1, setDateRange1] = useState([]);
  const [dateEnd, setDateEnd] = useState(props.lastUpdata);

  useEffect(() => {
    const currentDate = new Date(dateEnd);
    const currentDate2 = new Date(dateEnd);
    currentDate2.setFullYear(currentDate2.getFullYear() - 1);
    const end1 = new Date(currentDate);
    const end2 = new Date(currentDate2);
    end1.setMonth(end1.getMonth() - 3);
    end2.setMonth(end2.getMonth() - 3);
    const processedData = [];
  
    // Generate date range
    const dateRange = [];
    const dateRange2 = [];
    let currentDatePointer = new Date(end1);
  
    while (currentDatePointer <= currentDate) {
      dateRange.push(currentDatePointer.toISOString().split("T")[0]);
      currentDatePointer.setDate(currentDatePointer.getDate() + 1);
    }
    let currentDatePointer2 = new Date(end2);
  
    while (currentDatePointer2 <= currentDate2) {
      dateRange2.push(currentDatePointer2.toISOString().split("T")[0]);
      currentDatePointer2.setDate(currentDatePointer2.getDate() + 1);
    }
    setDateRange1(dateRange);
  
    const data = props.audit3 || [];
    
    // Process each batch
    let i=0
    data.forEach((yearBatch) => {
      const years = Object.keys(yearBatch).sort();
      const yearString = [];
      const greenSeriesMap = {};
      const redSeriesMap = {};
  
      years.forEach(year => {
        yearString.push(year);
        // Process all years in this batch
        // if (yearBatch[year]) {
          // Process Green data
          Object.entries(yearBatch[year].Green || {}).forEach(([month, days]) => {
            Object.entries(days).forEach(([day, value]) => {
              const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
              
              greenSeriesMap[dateStr] = (greenSeriesMap[dateStr] || 0) + value;
              // if (dateRange.includes(dateStr)) {
              //   greenSeriesMap[dateStr] = (greenSeriesMap[dateStr] || 0) + value;
              // }
              // if (dateRange2.includes(dateStr)) {
              //   greenSeriesMap[dateStr] = (greenSeriesMap[dateStr] || 0) + value;
              // }

            });
          });

          // Process Red data
          Object.entries(yearBatch[year].Red || {}).forEach(([month, days]) => {
            Object.entries(days).forEach(([day, value]) => {
              const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
              
              redSeriesMap[dateStr] = (redSeriesMap[dateStr] || 0) + value;
              // if (dateRange.includes(dateStr)) {
              //   redSeriesMap[dateStr] = (redSeriesMap[dateStr] || 0) + value;
              // }
              // if (dateRange2.includes(dateStr)) {
              //   redSeriesMap[dateStr] = (redSeriesMap[dateStr] || 0) + value;
              // }
            });
          });
        // }
      });

    // Convert to series format
    let greenSeries;
    let redSeries
    if(i>0){
      greenSeries = dateRange2.map(date => greenSeriesMap[date] || 0);
      redSeries = dateRange2.map(date => redSeriesMap[date] || 0);
    }else{
      greenSeries = dateRange.map(date => greenSeriesMap[date] || 0);
      redSeries = dateRange.map(date => redSeriesMap[date] || 0);
    }
  
    i++;

      // Add processed series to final data
      processedData.push({
        name: yearString.length > 1 ? `Green ${yearString[0]} - ${yearString[1]}` : `Green ${yearString[0]}`,
        data: greenSeries
      });
      processedData.push({
        name: yearString.length > 1 ? `Red ${yearString[0]} - ${yearString[1]}` : `Red ${yearString[0]}`,
        data: redSeries
      });
    });
  
    setChartData(processedData);
  }, [props.audit3, dateEnd]); 
  

  // useEffect(() => {
  //   const data = props.audit3;
  //   console.log("data :", data);
  //   const processedData = data.flatMap((yearData) =>
  //     Object.entries(yearData).map(([year, colors]) => {
  //       const series = Object.entries(colors).map(([color, months]) => ({
  //         name: `${color} Antibiotics prescribed in ${year}`,
  //         data: Object.values(months).flatMap((days) => Object.values(days)),
  //       }));
  //       return series;
  //     })
  //   );
  //   let furtherProceeded = processedData.flat();
  //   console.log("furtherProceeded :", furtherProceeded);
  //   setChartData(furtherProceeded);
  // }, []);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const startMonth = 2; // Start from February
  const endMonth = 5; // End at May
  const categories = []

  dateRange1.forEach((data,index ) => {

    const [monthStr, dayStr, yearStr] = data.split("-");
    const year = parseInt(yearStr);
    const month = parseInt(monthStr);
    const day = parseInt(dayStr);
    categories.push(data);
  });

  const chartOptionsLine = merge(BaseOptionChart(), {
    tooltip: {
      shared: true,
      intersect: false,
      marker: { show: false },
      x: {
        show: false,
        // format: 'dd MMM',
        formatter: undefined,
        title: {
          formatter: (seriesName) => seriesName,
        },
      },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => seriesName + ": ",
        },
      },
    },
    chart: {
      type: 'area',
      stacked: false,
      height: 364,
      zoom: {
        type: 'x',
        enabled: true,
        autoScaleYaxis: true
      },
      toolbar: {
        autoSelected: 'zoom'
      }
    },
    colors: ["#26734D", "#cc3311", "#b3e6cc", "#f9c4b8"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      borderColor: "#F5F5F5",
    },
    markers: {
      size: 0,
    },
    xaxis: {
      categories: categories,
      type: 'datetime',
      // labels: {
      //   rotate: -45,
      //   rotateAlways: false,
      //   datetimeUTC: false,
      //   format: 'dd MMM',
      //   formatter: function(value) {
      //     const date = new Date(value);
      //     return `${date.getDate()} ${monthNames[date.getMonth()]}`;
      //   }
      // }
    },
    yaxis: {
      min: 0,
      tickAmount: 7,
      forceNiceScale: true,
    },
    legend: {
      show: true,
      position: "bottom",
      offsetY: 10,
      formatter: function(seriesName, opts) {
        // Extract first word and year
        const firstWord = seriesName.split(' ')[0];
        const yearMatch = seriesName.match(/\d{4}$/);
        return seriesName;
      }
    },
    // annotations: {
    //   xaxis: [
    //     {
    //       x: 'Sept',
    //       borderColor: '#aa3377',
    //       label: {
    //         style: {
    //           color: '#aa3377',
    //         },
    //         text: 'Audit Start'
    //       }
    //     }
    //   ]
    // }
  });

  return (
    <Card sx={{ boxShadow: "none" }}>
      <br />
      <Box sx={{ p: 3, pb: 1 }} dir="ltr">
        <ReactApexChart
          type="line"
          series={chartData}
          options={chartOptionsLine}
          height={364}
        />
      </Box>
      <Box sx={{ mx: 5, mt: 10, border: 1, p: 5 }}>
        <Input fullWidth multiline rows={8} defaultValue="Your analysis here" />
      </Box>
    </Card>
  );
}
const mapState = (state) => ({
  audit3: state.audit.audit3,
  lastUpdata: state.user.lastUpload,
});

const mapDispatch = ({ antibiotics: { getGeneralAB } }) => ({
  getGeneralAB: () => getGeneralAB(),
});

export default connect(mapState, mapDispatch)(AppLine);
